import client from "../client";

export const vaccinationsApi = {
    async list(childId) {
        const { data } = await client.get(`/vaccinations/${childId}`);
        return data;
    },
    async update(childId, records) {
        const { data } = await client.put(`/vaccinations/${childId}`, { records });
        return data;
    },

    /**
     * One-dose rapid entry: mark a single vaccine as given for a
     * child. Returns the full per-child list (same shape as
     * `update`). Used by the Rapid Entry page; the Vaccination Tab
     * listens for the `phm:vaccination-updated` window event and
     * refetches when the childId matches.
     */
    async quickUpdate(childId, frontendId, patch) {
        const { data } = await client.patch(
            `/vaccinations/${childId}/${encodeURIComponent(frontendId)}`,
            patch,
        );
        return data;
    },

    /** Master vaccine catalogue (any authenticated user). */
    async catalogue() {
        const { data } = await client.get("/vaccines/catalogue");
        return data;
    },

    /**
     * Add a vaccine to the master catalogue. ``frontendId`` and
     * ``position`` are assigned server-side; the FE only supplies the
     * vaccine name + age label. The server backfills every active
     * child's record in the same transaction.
     */
    async create(payload) {
        const { data } = await client.post("/vaccines/catalogue", payload);
        return data;
    },

    /** Delete a master vaccine (cascades to child rows). */
    async deleteMaster(vaccineId) {
        const { data } = await client.delete(`/vaccines/catalogue/${vaccineId}`);
        return data;
    },

    /** Persist a new display order for the master list (drag-drop). */
    async reorder(orderedVaccineIds) {
        const { data } = await client.patch("/vaccines/catalogue/order", {
            orderedVaccineIds,
        });
        return data;
    },
};